import { RotateCw, Wrench } from 'lucide-react'
import { Button, LogoMark } from '@/components/ui'
import { useDocumentTitle } from '@/lib/hooks'
import { t } from '@/lib/i18n'

/** SHELL-019: full page while maintenance is running. */
export default function MaintenancePage({ message }: { message?: string | null }) {
  useDocumentTitle([t('Back soon')])
  return (
    <div className="grid min-h-dvh place-items-center bg-page px-4 py-12 text-text">
      <div className="w-full max-w-[460px] rounded-card border border-line bg-surface px-6 py-10 text-center shadow-card">
        <div className="mx-auto mb-6 w-fit">
          <LogoMark height={56} />
        </div>
        <span className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-surface-2 text-muted" aria-hidden="true">
          <Wrench size={22} strokeWidth={1.75} />
        </span>
        <h1 className="text-page-title">{t('We are releasing updates')}</h1>
        <p className="mt-3 text-body text-muted">
          {message || t('MG AI School is offline for a short while so we can ship improvements. Please check back in a few minutes.')}
        </p>
        <Button variant="secondary" className="mt-8" onClick={() => window.location.reload()}>
          <RotateCw size={18} strokeWidth={1.75} aria-hidden="true" />
          {t('Try again')}
        </Button>
      </div>
    </div>
  )
}
